import React from "react";
import "../MyComponents/style/About.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const About = () => {
  return (
    <div style={{ backgroundColor: "#Dbe6ea" }}>

      <Helmet>
        <title>About - Bunk4Study</title>
        <meta name="description" content="Know more about Bunk4Study" />
      </Helmet>

      <section class="text-gray-600 body-font">
        <div class="container px-5 py-24 mx-auto">
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="#62aec5"
              class="inline-block w-8 h-8 text-gray-400 mb-8"
              viewBox="0 0 975.036 975.036"
            >
              <path d="M925.036 57.197h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.399 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l36 76c11.6 24.399 40.3 35.1 65.1 24.399 66.2-28.6 122.101-64.8 167.7-108.8 55.601-53.7 93.7-114.3 114.3-181.9 20.601-67.6 30.9-159.8 30.9-276.8v-239c0-27.599-22.401-50-50-50zM106.036 913.497c65.4-28.5 121-64.699 166.9-108.6 56.1-53.7 94.4-114.1 115-181.2 20.6-67.1 30.899-159.6 30.899-277.5v-239c0-27.6-22.399-50-50-50h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.4 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l35.9 75.8c11.601 24.399 40.501 35.2 65.301 24.399z"></path>
            </svg>
            <p class="leading-relaxed text-xxxl article-text">
              We started Bunk4Study because in college everyone has to focus on
              extra study to get placement not on syllabus. But to take degree
              from college student have to pass semester exams as we are also
              college student and also face the same problem. After year of
              experience we came through the result that to prepare for semester
              one night before the exam the best way to is to go through
              previous year paper. Now problem arises it is very hectic work
              time taking to find previous year paper from library and asking
              seniors. That’s why we are here for you to support you to find
              previous year paper in single click for different colleges without
              any hardwork. Along the way we are also working on different
              branches like notes, study courses and many different sectors but
              right now we are focusing on Question Paper for different
              branches. We want to be your last night study mentor who helps you
              in passing semester exams and you can focus on your placement
              studies without any fear of back in semester exams. Every students
              download the question papers, notes and study material in this
              website. It is helpful for those students who don’t give much time
              in college studies and take more time placements will get more
              benefits in examinations. Every student pass in exam with good
              marks and he/she don’t spend much time in finding the question
              paper on different sites rather than all can find study materials
              in Bunk4Study. So all can get benefits in Bunk4Study.
            </p>
            <span class="inline-block h-1 w-10 rounded bg-blue-500 mt-8 mb-6"></span>
          </div>
        </div>
      </section>
      <Link to={"/Blog"}>
        {" "}
        <button
          class="btn btn-success btn-lg my-2 our-blogs"
          title="Click Here To See our Blogs"
        >
          Our Blogs
        </button>
      </Link>
    </div>
  );
};

export default About;
